// src/main.js

import { createApp } from 'vue';
import App from './App.vue';
import router from './router'; // Import the router

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// Import FontAwesome core
import { library } from '@fortawesome/fontawesome-svg-core';

// Import specific FontAwesome icons
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';

import { faDumbbell, faHeartbeat, faAppleAlt, faUserTie } from '@fortawesome/free-solid-svg-icons';

// Import FontAwesome Vue component
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// Add the icons to the library

library.add(faFacebook, faInstagram, faDumbbell, faHeartbeat, faAppleAlt, faUserTie);



// Create Vue app instance
const app = createApp(App);

// Register FontAwesomeIcon globally
app.component('font-awesome-icon', FontAwesomeIcon);

// Use plugins and mount app
app.use(router);
app.mount('#app');